import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberCommunityPostsPage from "@/pages/member/MemberCommunityPostsPage";

export const Route = createFileRoute("/member/community-posts")({
  head: () => pageHead("Member · Community Posts", "AKIVA member · community posts portal.", "/member/community-posts", true),
  component: MemberCommunityPostsPage,
});
